import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import TextBox from 'devextreme-react/text-box';
import { Button } from 'devextreme-react/button';
import NumberBox from 'devextreme-react/number-box';
import ValidationSummary from 'devextreme-react/validation-summary';
import {
  Validator,
  RequiredRule,
} from 'devextreme-react/validator';

import "../Maintenence/AddSeedLot.css";
import AddSeedLotDialog from "../Dialoges/AddSeedLotDialog";
import axios from "axios";
import routes from "../../../assets/apiRoutes.json"
const validationSummary = React.createRef();

const AddSeedLot = (props) => {
  var accessToken = props.oidc.user.access_token;
  const selectedCompanyName =
    props.ReceiptReducer.selectedCompanyName !== "" &&
      props.ReceiptReducer.selectedCompanyName != undefined
      ? props.ReceiptReducer.selectedCompanyName
      : "SB";
  const [seedLot, setSeedLot] = useState({
    locWarehouse: props.oidc.user.profile.hasOwnProperty("SODADDSEEDLOTWAREHOUSE") ? props.oidc.user.profile.SODADDSEEDLOTWAREHOUSE : "RSFCI",
    germ: "",
    itemCode: "",
    custGerm: "",
    location: props.oidc.user.profile.hasOwnProperty("SODADDSEEDLOTLOCATION") ? props.oidc.user.profile.SODADDSEEDLOTLOCATION : "STRT001B",
    purity: "",
    comment: "",
    itemSpecies: "",
    item: "",
    seedslb: "",
    lot: "",
    pounds: "",
    companyid: selectedCompanyName,
    lastupdateuserid: props.oidc.user.profile.sub,
    creationuserid: props.oidc.user.profile.sub,
  });

  const {
    locWarehouse,
    germ,
    itemCode,
    custGerm,
    location,
    purity,
    item,
    itemSpecies,
    seedslb,
    lot,
    comment,
    pounds,
    companyid,
    lastupdateuserid,
    creationuserid,
  } = seedLot;

  const onInputChange = useCallback((e, name) => {
    setSeedLot(prevState => ({
      ...prevState,
      [name]: e.value,
    }));
  }, [setSeedLot]);

  const [openSeedLot, setOpenSeedLot] = useState(false);
  const openAddSeedLotDialog = () => {
    setOpenSeedLot(true);
  };
  const resetAddSeedLot = (e) => {
    setSeedLot({
      locWarehouse: props.oidc.user.profile.hasOwnProperty("SODADDSEEDLOTWAREHOUSE") ? props.oidc.user.profile.SODADDSEEDLOTWAREHOUSE : "RSFCI",
      germ: "",
      itemCode: "",
      custGerm: "",
      location: props.oidc.user.profile.hasOwnProperty("SODADDSEEDLOTLOCATION") ? props.oidc.user.profile.SODADDSEEDLOTLOCATION : "STRT001B",
      purity: "",
      comment: "",
      item: "",
      itemSpecies: "",
      seedslb: "",
      lot: "",
      pounds: "",
      companyid: selectedCompanyName,
      lastupdateuserid: props.oidc.user.profile.sub,
      creationuserid: props.oidc.user.profile.sub,
    });
  };
  const saveSeedLot = (e) => {
    e.preventDefault();
    setSeedLot({ ...seedLot, ["companyid"]: selectedCompanyName });
    setSeedLot({
      ...seedLot,
      ["lastupdateuserid"]: props.oidc.user.profile.sub,
    });
    setSeedLot({
      ...seedLot,
      ["creationuserid"]: props.oidc.user.profile.sub,
    });
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${routes.maintenance.InsertSeedInventory}`,
        seedLot,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          }
        }
      )
      .then((res) => {
        openAddSeedLotDialog();
        resetAddSeedLot();
      })
      .catch((err) => {
        console.log(err, "err in save record");
      });
  };
  const closeAddSeedLotDialog = () => {
    setOpenSeedLot(false);
  };
  return (
    <div className="m-0 h-100 overflow-hidden" style={{ width: "100%" }}>
              <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          Add Seed Lot
                        </h6>
                      </div>
      <div className="card-container">
        <div className="card-content">
          <form className="addlot-form" onSubmit={(e) => saveSeedLot(e)}>
            <div className="row">
              <div className="col-md-6">
                <TextBox
                  id="warehouse"
                  type="text"
                  name="locWarehouse"
                  value={locWarehouse}
                  readOnly={true}
                  stylingMode='outlined'
                  labelMode="static"
                  label="Warehouse"
                >
                  <Validator>
                  <RequiredRule message="Warehouse is required" />
                  </Validator>
                </TextBox>
              </div>
              <div className="col-md-6">
                <NumberBox
                  id="calc-germ"
                  onValueChanged={(e) => onInputChange(e, "germ")}
                  name="germ"
                  value={germ}
                  stylingMode='outlined'
                  labelMode="static"
                  label="Calc Germ"
                  >
                  <Validator>
                  <RequiredRule message="Calc Germ is required" />
                  </Validator>
                </NumberBox>
              </div>
            </div>
            <div className="row accordianLastRow">
              <div className="col-md-6">
                <TextBox
                  id="species-name"
                  onValueChanged={(e) => onInputChange(e, "itemSpecies")}
                  name="itemSpecies"
                  value={itemSpecies}
                  stylingMode='outlined'
                  labelMode="static"
                  label="Species Name"
                />
              </div>
              <div className="col-md-6">
                <NumberBox
                  id="custc-germ"
                  onValueChanged={(e) => onInputChange(e, "custGerm")}
                  name="custGerm"
                  value={custGerm}
                  stylingMode='outlined'
                  labelMode="static"
                  label="Cust Germ"
                  >
                  <Validator>
                  <RequiredRule message="Cust Germ is required" />
                  </Validator>
                </NumberBox>
              </div>
            </div>
            <div className="row accordianLastRow">
              <div className="col-md-6">
                <TextBox
                  id="species-code"
                  onValueChanged={(e) => onInputChange(e, "itemCode")}
                  name="itemCode"
                  value={itemCode}
                  stylingMode='outlined'
                  labelMode="static"
                  label="Species Code"
                  >
                  <Validator>
                  <RequiredRule message="Species Code is required" />
                  </Validator>
                </TextBox>
              </div>
              <div className="col-md-6">
                <NumberBox
                  id="purity"
                  onValueChanged={(e) => onInputChange(e, "purity")}
                  name="purity"
                  value={purity}
                  stylingMode='outlined'
                  labelMode="static"
                  label="Purity"
                  >
                  <Validator>
                  <RequiredRule message="Purity is required" />
                  </Validator>
                </NumberBox>
              </div>
            </div>
            <div className="row accordianLastRow">
              <div className="col-md-6">
                <TextBox
                  id="location"
                  type="text"
                  onValueChanged={(e) => onInputChange(e, "location")}
                  name="location"
                  value={location}
                  stylingMode='outlined'
                  labelMode="static"
                  label="Location"
                  >
                  <Validator>
                  <RequiredRule message="Location is required" />
                  </Validator>
                </TextBox>
              </div>
              <div className="col-md-6">
                <NumberBox
                  id="seeds-per-lb"
                  onValueChanged={(e) => onInputChange(e, "seedslb")}
                  name="seedslb"
                  value={seedslb}
                  stylingMode='outlined'
                  labelMode="static"
                  label="Seeds Per LB"
                  >
                  <Validator>
                  <RequiredRule message="Seeds Per LB is required" />
                  </Validator>
                </NumberBox>
              </div>
            </div>
            <div className="row accordianLastRow">
              <div className="col-md-6">
                <TextBox
                  id="seed-item"
                  type="text"
                  onValueChanged={(e) => onInputChange(e, "item")}
                  name="item"
                  value={item}
                  stylingMode='outlined'
                  labelMode="static"
                  label="Seed Item"
                  >
                  <Validator>
                  <RequiredRule message="Seed Item is required" />
                  </Validator>
                </TextBox>
              </div>
              <div className="col-md-6 col-pound">
                <TextBox
                  id="pounds"
                  type="text"
                  onValueChanged={(e) => onInputChange(e, "pounds")}
                  name="pounds"
                  value={pounds}
                  stylingMode='outlined'
                  labelMode="static"
                  label="Pounds"
                  >
                  <Validator>
                  <RequiredRule message="Pounds is required" />
                  </Validator>
                </TextBox>
              </div>
            </div>
            <div className="row accordianLastRow">
              <div className="col-md-6">
                <TextBox
                  id="seed-lot"
                  type="text"
                  onValueChanged={(e) => onInputChange(e, "lot")}
                  name="lot"
                  value={lot}
                  stylingMode='outlined'
                  labelMode="static"
                  label="Seed Lot"
                >
                   <Validator>
                  <RequiredRule message="Seed Lot is required" />
                  </Validator>
                </TextBox>
              </div>
              <div className="col-md-6">
                <TextBox
                  id="comment"
                  onValueChanged={(e) => onInputChange(e, "comment")}
                  name="comment"
                  mode="textArea"
                  value={comment}
                  stylingMode='outlined'
                  labelMode="static"
                  label="Comment"
                  >
                 
                </TextBox>
              </div>

            </div>
            <div className="row accordianLastRow">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-12 p-0">
                  <Button
                      type="default"
                      stylingMode="contained"
                      useSubmitBehavior={true}
                      text="Add Record" />
                                <Button
                                    onClick={resetAddSeedLot}
                                    style={{marginLeft:'10px'}}
                                    text="Reset"
                                    useSubmitBehavior={false}
                                    stylingMode="contained">
                                </Button>
                   
                  </div>
                  
                </div>
              </div>
            </div>
          </form>
        </div>
        <AddSeedLotDialog
          openSeedLot={openSeedLot}
          openAddSeedLotDialog={openAddSeedLotDialog}
          closeAddSeedLotDialog={closeAddSeedLotDialog}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(AddSeedLot);
